var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBodyTypeCuddly(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "50px",
    viewBox: "0 0 34 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBodyTypeCuddly") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.179303797 0.156329114 8.40525316 0.156329114 8.40525316 8.62 0.179303797 8.62 0.179303797 0.156329114"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.129620253 38.6075949 11.8865823 38.6075949 11.8865823 0.000189873418 0.129620253 0.000189873418 0.129620253 38.6075949"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 10.9427106 0 0 16.2758228 0 16.2758228 10.9427106 1.72484214e-15 10.9427106"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "17.3379747 11.5906454 17.3379747 0.358164557 0.495 0.358164557 0.495 11.5906454 17.3379747 11.5906454"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BodyType-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-173.000000, -375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cuddly",
    transform: "translate(173.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(12.658228, 0.476835)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29196203,8.62 C5.44449367,8.62 6.41791139,8.20227848 7.2128481,7.36746835 C8.00778481,6.53329114 8.40525316,5.53962025 8.40525316,4.38772152 C8.40525316,3.23518987 8.00778481,2.24151899 7.2128481,1.40734177 C6.41791139,0.572531646 5.44449367,0.156075949 4.29196203,0.156075949 C3.14006329,0.156075949 2.16664557,0.572531646 1.37170886,1.40734177 C0.576772152,2.24151899 0.179303797,3.23518987 0.179303797,4.38772152 C0.179303797,5.53962025 0.576772152,6.53329114 1.37170886,7.36746835 C2.16664557,8.20227848 3.14006329,8.62 4.29196203,8.62",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(11.392405, 11.236329)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8865823,2.63626582 C10.1416456,2.54639241 9.19987342,1.26601266 9.04860759,0.000189873418 L2.4656962,0.000189873418 C2.22518987,1.26601266 1.48658228,2.47170886 0.728987342,3.60968354 C0.557468354,3.86664557 0.350506329,3.885 0.129620253,4.08563291 L1.44481013,38.6077848 L4.00873418,38.6077848 L6.00810127,17.4318354 L8.59734177,38.6077848 L10.8125316,38.6077848 L11.4308861,2.90462025 L11.8865823,2.63626582 Z",
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 11.236329)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3188608,0 L1.09101266,7.06075949 C0.609367089,7.35063291 0.277721519,7.71898734 0.0967088608,8.28797468 C-0.0849367089,8.85696203 -0.0108860759,9.35632911 0.316962025,9.84683544 C0.646075949,10.3373418 1.09481013,10.6582278 1.66443038,10.8398734 C2.23278481,11.0221519 2.75810127,10.9601266 3.23911392,10.6696203 L16.2758228,2.99810127 C16.2758228,2.99810127 15.2207595,1.19873418 14.9941772,0.108227848 C14.9783544,0.0310126582 14.9688608,0 14.9574684,0 L13.3188608,0 Z",
    id: "Fill-7",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(16.455696, 10.603418)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93993671,0.358164557 L2.72348101,0.653101266 C2.57537975,0.729683544 2.42158228,0.80056962 2.25196203,0.858797468 C1.81778481,1.00816456 1.38613924,1.16512658 0.956392405,1.32651899 C0.956392405,1.34677215 0.961455696,1.36639241 0.961455696,1.38537975 C0.945,2.17018987 0.757658228,2.88348101 0.495,3.57968354 L0.784873418,3.47905063 L14.088038,11.2929747 C14.5677848,11.5866456 15.0968987,11.6625949 15.6766456,11.5227215 C16.2563924,11.3822152 16.7057595,11.048038 17.0279114,10.519557 C17.3494304,9.99170886 17.4215823,9.44297468 17.2418354,8.87272152 C17.0633544,8.30373418 16.7336076,7.87335443 16.2544937,7.57968354 L3.93993671,0.358164557 Z",
    id: "Fill-10",
    fill: "#FFFFFF",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.0097468,15.8375949 C11.5287342,15.8375949 8.68063291,18.6856962 8.68063291,22.1667089 C8.68063291,25.6477215 11.5287342,28.4958228 15.0097468,28.4958228 C18.4913924,28.4958228 21.3394937,25.6477215 21.3394937,22.1667089 C21.3394937,18.6856962 18.4913924,15.8375949 15.0097468,15.8375949 L9.08848195,15.8375949 L5.45430343,19.4717735",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5336709,15.8375949 C15.0526582,15.8375949 12.204557,18.6856962 12.204557,22.1667089 C12.204557,25.6477215 15.0526582,28.4958228 18.5336709,28.4958228 C22.0153165,28.4958228 24.8634177,25.6477215 24.8634177,22.1667089 C24.8634177,18.6856962 22.0153165,15.8375949 18.5336709,15.8375949",
    id: "Fill-15",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBodyTypeCuddly);
export default __webpack_public_path__ + "static/media/icBodyTypeCuddly.795d34764b29d1c9e9444f83a90e79ec.svg";
export { ForwardRef as ReactComponent };